
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {CSSTransitionGroup} from 'react-transition-group'
import classnames from 'classnames'
import Select from 'components/Select'

export default class FormSelect extends React.Component {
  static propTypes = {
    meta: PropTypes.shape({
      invalid: PropTypes.bool,
      touched: PropTypes.bool,
      pristine: PropTypes.bool,
      error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
    }).isRequired,
    input: PropTypes.shape({
      value: PropTypes.string,
      onChange: PropTypes.func,
      onBlur: PropTypes.func,
      onFocus: PropTypes.func
    }).isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    label: PropTypes.string,
    options: PropTypes.array,
    hint: PropTypes.string,
    emptyValue: PropTypes.string,
    searchable: PropTypes.bool
  }

  render() {
    const {meta: {touched, error}, className, disabled} = this.props
    const classNames = classnames('form-select', className, {
      'is-invalid': touched && error,
      'is-disabled': disabled
    })

    return (
      <div className={classNames}>
        <div className='form-select_field'>
          {this.renderLabel()}
          {this.renderSelect()}
          <CSSTransitionGroup
            transitionName='error'
            transitionEnterTimeout={200}
            transitionLeaveTimeout={200}>
            {this.renderErrors()}
          </CSSTransitionGroup>
        </div>
        {this.renderHint()}
      </div>
    )
  }

  renderLabel() {
    const {label} = this.props
    if (!label) return null

    return <label>{label}</label>
  }

  renderSelect() {
    const {
      options, emptyValue, searchable,
      input: {value, onChange, onFocus, onBlur},
      meta: {touched, error},
      disabled
    } = this.props

    return (
      <Select
        options={options}
        value={value}
        disabled={disabled}
        emptyValue={emptyValue}
        searchable={searchable}
        onSelect={this.onSelect}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        invalid={touched && error}
      />
    )
  }

  renderErrors() {
    const {error, touched} = this.props.meta

    if (touched && error && (typeof error === 'string')) {
      return <div className='form-select_error'>{error}</div>
    } else {
      return null
    }
  }

  renderHint() {
    const {hint} = this.props
    if (!hint) return null

    return <div className='form-input_hint'>{hint}</div>
  }

  onSelect = option => {
    const {input: {onChange}} = this.props
    const {value} = option

    onChange && onChange(value)
  }
}



// WEBPACK FOOTER //
// ./client/components/FormSelect/index.js